import { render, staticRenderFns } from "./IconArrowNegative.vue?vue&type=template&id=1b20a306&"
import script from "./IconArrowNegative.vue?vue&type=script&lang=ts&"
export * from "./IconArrowNegative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports